import ApiClientCore from './core';

import MiscMixins from './mixins/misc';
import SurveyMixins from './mixins/survey';
import PdfMixins from './mixins/pdf';
import CliniqueMixins from './mixins/clinique';

export default class ApiClient extends ApiClientCore {
  // eslint-disable-next-line class-methods-use-this
  mixins() {
    return {
      misc: MiscMixins,
      survey: SurveyMixins,
      pdf: PdfMixins,
      clinique: CliniqueMixins,
    };
  }
}
